import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: "C'est discret ?",
  a: "Oui. L'achat apparaît de manière confidentielle sur votre relevé bancaire."
}, {
  q: "C'est dur à appliquer ?",
  a: 'Non. Les scripts du Lexique Secret sont prêts à être copiés-collés. Vous pouvez commencer ce soir même.'
}, {
  q: 'Et si je suis timide ou introvertie ?',
  a: "C'est exactement pour vous. Le guide fait le travail psychologique à votre place. Vous n'avez qu'à suivre le protocole."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 md:py-24 bg-deep-black relative z-10 border-t border-white/5" data-id="element-36">
      <div className="max-w-3xl mx-auto px-6" data-id="element-37">
        <FadeIn data-id="element-38">
          <h2 className="font-playfair text-3xl text-center text-cream mb-12" data-id="element-39">
            Questions Fréquentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-40">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-41">
              <div className="border border-white/10 rounded-2xl overflow-hidden bg-white/[0.02]" data-id="element-42">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-43">
                  <span className="font-playfair text-lg text-cream" data-id="element-44">
                    {faq.q}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} data-id="element-45">
                    <ChevronDown className="text-champagne-gold w-5 h-5" data-id="element-46" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-47">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-48">
                      <div className="px-6 pb-6 text-muted-cream font-light text-sm leading-relaxed" data-id="element-49">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}